import { useEffect, useState } from 'react';
import defaultLogo from '~/images/logo.png';

interface LogoProps {
    src?: string;
    className?: string;
    imgClassName?: string;
    width?: number;
    height?: number;
    alt?: string;
    to?: string | null;
    href?: string;
    onClick?: () => void;
}

function Logo({
    src = defaultLogo,
    className,
    imgClassName,
    width = 120,
    height,
    alt = 'Logo',
    to = '/',
    href,
    onClick,
}: LogoProps) {
    const [imageSrc, setImageSrc] = useState(src || defaultLogo);

    useEffect(() => {
        setImageSrc(src || defaultLogo);
    }, [src]);

    const image = (
        <img
            src={imageSrc}
            alt={alt}
            width={width}
            height={height}
            className={imgClassName}
            onError={() => {
                if (imageSrc !== defaultLogo) {
                    setImageSrc(defaultLogo);
                }
            }}
        />
    );

    if (href) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick}>
                {image}
            </a>
        );
    }

    if (to === null) {
        return (
            <span className={className} onClick={onClick}>
                {image}
            </span>
        );
    }

    return (
        <a href={to} className={className} onClick={onClick}>
            {image}
        </a>
    );
}

export default Logo;
